var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0C4.44772 0 4 0.447715 4 1V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V5.48479C20 4.20801 18.8199 3.25815 17.5726 3.53099L15.4286 4L15.843 2.54944C16.2081 1.27181 15.2487 0 13.92 0H5ZM12 6C12.5523 6 13 6.44772 13 7V10H16C16.5523 10 17 10.4477 17 11C17 11.5523 16.5523 12 16 12H13V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V12H8C7.44772 12 7 11.5523 7 11C7 10.4477 7.44772 10 8 10H11V7C11 6.44772 11.4477 6 12 6Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7L0.28266 18.7751C0.138056 19.4018 0.613966 20 1.25705 20H3V7Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.d90be027caa6db8ccc4acdd4ea0a6215.svg";
export { ForwardRef as ReactComponent };